var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStickyArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 61,
    height: 47.77,
    viewBox: "0 0 61 47.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_83",
    x: 0,
    y: 0,
    width: 61,
    height: 47.77,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Component_12_2",
    "data-name": "Component 12 \\u2013 2",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_83)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "grey"
    },
    id: "Path_83-2",
    "data-name": "Path 83",
    d: "M5306.616,870.29l-1.653-1.654,1.653-1.654,1.654,1.654Zm3.308,3.308,1.654-1.654-1.654-1.654-1.653,1.654Zm-4.961-1.654-1.654-1.654-1.653,1.654,1.653,1.654Zm8.269,4.962,1.654-1.654-1.654-1.654-1.654,1.654Zm-11.577-1.654L5300,873.6l-1.653,1.654,1.653,1.654Zm4.961,8.269,1.654-1.654-1.654-1.654-1.653,1.654Zm6.616,3.308h0l-1.653,1.654,1.653,1.654h0l1.654-1.654Zm3.308-6.615,1.654-1.654-1.654-1.654-1.654,1.654Zm-14.884-1.654,1.653,1.654,1.654-1.654-1.654-1.654Zm21.5,11.578h0l-1.653,1.654,1.653,1.654h0l1.654-1.654-1.654-1.654Zm4.962-1.655-1.654-1.654h0l-1.654,1.654,1.654,1.654h0Zm-8.27,4.962h0l-1.653,1.654,1.653,1.654h0l1.654-1.654-1.654-1.654Zm-14.883-18.193,1.653,1.654,1.654-1.654-1.654-1.654Zm3.308,3.308,1.653,1.654,1.654-1.654-1.654-1.654Zm0,6.615,1.653,1.654,1.654-1.654-1.654-1.654Zm3.308-3.308,1.654,1.654,1.654-1.654-1.654-1.654Zm-4.963,11.577-1.654,1.654,1.654,1.654,1.654-1.654Zm4.962,4.961-1.654-1.654-1.654,1.654,1.654,1.654Zm9.923-13.231,1.653,1.654h0l1.654-1.654-1.654-1.654h0Zm-4.961,1.653h0l1.654-1.654-1.654-1.654h0l-1.654,1.654,1.654,1.654Zm-13.231,13.232,1.654-1.654-1.654-1.654-1.653,1.654Zm4.961,1.654-1.654-1.654-1.654,1.654,1.654,1.654Zm-3.308,6.615,1.654,1.654,1.654-1.654-1.654-1.654Zm3.308-3.308,1.654,1.654,1.654-1.654-1.654-1.654Zm6.616-6.615,1.654,1.654,1.654-1.654-1.654-1.654Zm-3.308,3.308,1.653,1.654,1.654-1.654-1.654-1.654Zm-8.27,1.654-1.653,1.654,1.653,1.654,1.654-1.654ZM5300,900.059l-1.654,1.654,1.654,1.654,1.654-1.654Zm16.539-6.616h0l1.654-1.654-1.654-1.654h0l-1.654,1.654,1.654,1.654Zm-1.654,1.655-1.654-1.654-1.653,1.654,1.653,1.654Zm-4.962-4.962-1.654,1.654,1.654,1.654,1.654-1.654Zm9.924,0h0l1.654-1.654-1.654-1.654h0l-1.653,1.654,1.653,1.654Zm-1.654-8.268,1.653,1.654h0l1.654-1.654-1.654-1.654h0Z",
    transform: "translate(918.98 -5292.35) rotate(90)",
    fill: "#373737"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyArrow);
export default __webpack_public_path__ + "static/media/sticky-arrow.9f75ee92427dfdfaa3294e3517ace534.svg";
export { ForwardRef as ReactComponent };